import React from 'react';
import { CheckCircle } from 'lucide-react';
import Button from '../../common/Button';
import { useContactForm } from '../../../hooks/useContactForm';
import { classNames } from '../../../utils/helpers';
import styles from './ContactForm.module.css';

const ContactForm = () => {
  const {
    formData,
    errors,
    isSubmitting,
    isSuccess,
    submitError,
    updateField,
    submitForm,
    resetForm,
    isValid,
  } = useContactForm();

  if (isSuccess) {
    return (
      <div className={styles.success}>
        <CheckCircle className={styles.successIcon} />
        <h3 className={styles.successTitle}>Message sent!</h3>
        <p className={styles.successText}>
          Thanks for reaching out. We'll get back to you as soon as possible.
        </p>
        <button onClick={resetForm} className={styles.resetButton}>
          Send another message
        </button>
      </div>
    );
  }

  return (
    <div className={styles.form}>
      <div className={styles.field}>
        <label className={styles.label}>Name *</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => updateField('name', e.target.value)}
          className={classNames(styles.input, { [styles.inputError]: errors.name })}
          placeholder="Your full name"
        />
        {errors.name && <span className={styles.errorText}>{errors.name}</span>}
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Email *</label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => updateField('email', e.target.value)}
          className={classNames(styles.input, { [styles.inputError]: errors.email })}
          placeholder="your@email.com"
        />
        {errors.email && <span className={styles.errorText}>{errors.email}</span>}
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Subject *</label>
        <input
          type="text"
          value={formData.subject}
          onChange={(e) => updateField('subject', e.target.value)}
          className={classNames(styles.input, { [styles.inputError]: errors.subject })}
          placeholder="What is this about?"
        />
        {errors.subject && <span className={styles.errorText}>{errors.subject}</span>}
      </div>

      <div className={styles.field}>
        <label className={styles.label}>Message *</label>
        <textarea
          rows={6}
          value={formData.message}
          onChange={(e) => updateField('message', e.target.value)}
          className={classNames(styles.textarea, { [styles.inputError]: errors.message })}
          placeholder="Tell us more about your inquiry..."
        />
        {errors.message && <span className={styles.errorText}>{errors.message}</span>}
      </div>

      {submitError && (
        <p className={styles.submitError}>{submitError}</p>
      )}

      <Button
        onClick={submitForm}
        loading={isSubmitting}
        disabled={!isValid}
        fullWidth
        size="lg"
        className={classNames(
          styles.submitButton,
          { [styles.submitButtonReady]: isValid }
        )}
      >
        Send Message
      </Button>
    </div>
  );
};

export default ContactForm;
